import React from 'react';

const ErrorNote = ({children, className}) => (
  <p className={`text-red mt-0 ${className}`}>{children}</p>
);

export default ErrorNote;
